/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-11-12T09:55:24.329
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	getReportPlaceorderEditInit,
	getReportPlaceorderView
} from '@api/report/ReportPlaceorder';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary)
	},
	actions: {
		getReportPlaceorderEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getReportPlaceorderEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getReportPlaceorderView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getReportPlaceorderView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
	}
};
